import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],

})
export class HomeComponent implements OnInit {

  avatarQues: boolean = true;
  avatarQues2: boolean = false;
  avatarQues3: boolean = false;
  avatarIndex = 0;
  avatarIndex1 = 0;
  quesFirst : boolean = true; 
  quesTwo : boolean = false; 

  // avatarQues : [true, false,]
  // stepOne(val){
  stepOne() {
    this.avatarQues = false;
    this.avatarQues2 = true;
    // this.avatarIndex = val;
  }

  stepTwo() {
    this.avatarQues = false;
    this.avatarQues2 = false;
    this.avatarQues3 = true;
    // this.avatarIndex1 = val;
  }

  stepBack() {
    this.avatarQues = true;
    this.avatarQues2 = false;
  }

  stepBack2() {
    this.avatarQues2 = true;
    this.avatarQues3 = false;
  }
  stepPart2(){
    this.quesFirst = false; 
    this.quesTwo = true; 

  }

  constructor() { }

  ngOnInit(): void {
  }

}
